import React, { ReactNode, FC, ReactElement } from 'react'
import { SiteFooter } from '@scentregroup/ui'
import { ThemesColour } from '../../pages/promotional-page'

interface FooterProps {
  children: ReactNode
  colour?: ThemesColour
}

const Footer: FC<FooterProps> = ({
  children,
  colour,
  ...restProps
}): ReactElement => {
  const links = [
    { label: 'Careers', href: 'https://www.scentregroup.com/careers' },
    {
      label: 'Leasing & Media',
      href: 'https://www.scentregroup.com/Retail-Solutions/Contact-us',
    },
    {
      label: 'Privacy Policy',
      href: '/privacy-policy',
    },
    {
      label: 'Terms & Conditions',
      href: '/terms-and-conditions',
    },
  ]
  return (
    <SiteFooter
      content={children}
      links={links}
      {...restProps}
      colour={colour}
    />
  )
}

export default Footer
